export default "__VITE_ASSET__ecdc2ca4__"